export default __webpack_public_path__ + "63d024c5d6c1f56dd2949457284549f3.svg";